<template>
    <b-input-group class="mb-3">
        <b-form-input
            id="current-date"
            v-model="formatted_current_date"
            type="text"
            autocomplete="off"
            disabled
            size="sm"
            class="bg-white"
        />
        <b-input-group-append>
            <b-form-datepicker
                v-model="form.current_date"
                size="sm"
                button-only
                reset-button
                label-reset-button="Effacer le filtre"
                right
                label-prev-year="Année précédente"
                label-next-year="Année prochaine"
                label-prev-month="Mois précédent"
                label-next-month="Mois prochain"
                label-current-month="Mois actuel"
                label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                start-weekday="1"
                aria-controls="current-date"
                :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                }"
                locale="fr"
                @context="formatCurrentDate"
                @hidden="setBeforeFilter"
            >
            </b-form-datepicker>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'BeforeFilter',

    mixins: [DataUpdater],

    data() {
        return {
            form: {
                current_date: null,
            },
            formatted_current_date: '',
        }
    },

    async created() {
        // await this.$store.dispatch('reportingVM/getFilters')
        this.form.current_date = this.beforeFilter
    },

    methods: {
        formatCurrentDate(ctx) {
            this.formatted_current_date = this.dateIsSet
                ? `Avant le ${ctx.selectedFormatted}`
                : 'Avant le...'
        },

        async setBeforeFilter() {
            if (this.dateIsSet) {
                await this.$store.dispatch(
                    'reportingVM/setBeforeFilter',
                    this.form.current_date
                )
            } else {
                await this.$store.dispatch('reportingVM/resetBeforeFilter')
            }
            await this.$store.dispatch('reportingVM/getFilters')
            this.updateData()
        },
    },

    computed: {
        ...mapState({
            beforeFilter: (state) => state.reportingVM.filters.before,
        }),

        updateAfterFiltering() {
            return (
                this.activePage !== 'ownTasks' &&
                this.activePage !== 'delegatedTasks'
            )
        },

        dateIsSet() {
            return this.form.current_date === null
                ? false
                : this.form.current_date.length > 0
        },
    },
}
</script>

<style scoped></style>
